<script>
import Layout from '@layouts/primary'
import { serviceMethods, pickupRequestMethods } from '@state/helpers'
import store from '@state/store'
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'My Services',
    meta: [{ name: 'my_services', content: 'My Services' }],
  },
  components: { Layout },
  data() {
    return {
      dateDialog:false,
      headers:[
        {text:"Transaction Id",value:"transaction_id"},
        {text:"Service Title",value:"service_title"},
        {text:"Pickup Date",value:"service_title"},
        {text:"Status",value:"status"}
      ],
      services: [],
      pickupRequests:[],
      serviceTypes:[],
      serviceTypeName: null,
      showService: false,
      newPickupRequest:{
        serviceId:null,
        service_title: null,
        clientId:null,
        pickupDate:new Date().toISOString().substr(0, 10),
        pickupTimeWindow:'adsasdasd',
        notes:null
      },
      dictionary: {
        attributes: {
          email: 'E-mail Address',
        },
        custom: {
          name: {
            required: () => 'Name can not be empty',
            max: 'The name field may not be greater than 10 characters',
          },
          select: {
            required: 'Select field is required',
          },
        },
      },
      newServiceFlag: false,
      requestCollection: false
    }
  },
  mounted() {
    let userId = store.getters['auth/getClientId'];
    this.$validator.localize('en', this.dictionary)
    this.getServiceByClientId({id: userId}).then(response => {
      let obj = this.$store.state.services.objects

      for (let v in obj) {
        // obj[v].id=parseInt(obj[v].id)
        this.services.push(obj[v])
      }
      this.getClientPickupRequests().then(res=>{
        let obj = this.$store.state.pickuprequest.clientobjects;
        for (let v in obj) {
          // obj[v].id=parseInt(obj[v].id)
          // console.log(obj[v].pickup_date)
          // obj[v].pickup_date = moment.unix(obj[v].pickup_date/1000).format("MMM Do YYYY")
          this.pickupRequests.push(obj[v])
        }
      })
    })
  },
  methods: {
    ...serviceMethods,
    ...pickupRequestMethods,
    submit() {
      this.$validator.validateAll()

    },
    clear() {
      this.$validator.reset()
      this.newService = false
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    request(){
      this.createPickupRequest(this.newPickupRequest);
      this.requestCollection = false;
      location.reload();
    },
    requestPickup(service){
      this.requestCollection = true;
      this.newPickupRequest.serviceId = service.id;
      this.newPickupRequest.service_title = service.service_title;
      this.newPickupRequest.clientId = service.client_id.id;
      this.newPickupRequest.notes = '';
    },
    updateDatetime(datetime){
      this.newPickupRequest.pickupDate=datetime;
    },
    onDateChange(date){
      // Convert Date format
      // this.computedDateFormattedMomentjs()
      this.dateDialog = false;
    },
  },
}
</script>

<template>
  <Layout>
    <VContainer>

      <h2 :class="$style.routeHeader">
        My Services
      </h2>
      <br>
      <VLayout
        wrap
        row
      >
        <VFlex
          v-for="service in services"
          :key="parseInt(service.id)"
          xs12
          sm12
          md4
          lg4
          offset-md1
          offset-lg1
        >
          <br>
          <br>
          <VCard class="v-card-padding client-card">
            <VLayout
              row
            >
              <VFlex
                xs12
                sm12
                md12
                lg12
              >
                <h3>{{ service.service_title }}</h3>
                <br>
                <p><i class="fas fa-file-alt" /> {{ service.description }}</p>
                <p><i class="fas fa-user" /> <strong> Client:</strong>{{ service.client_id.client_name }}</p>
                <p v-if="service.service_type_id">
                  <i class="fas fa-trash" />
                  <strong> Type:</strong>{{ service.service_type_id.name }}
                </p>
                <VSpacer />
              </VFlex>
            </VLayout>
            <VFlex
              xs12
              sm12
              md10
              lg10
              offset-md1
              offset-lg1
            >
              <VBtn
                color="blue"
                block
                @click.native="requestPickup(service)"
              >
                Request Pick up
              </VBtn>
            </VFlex>
          </VCard>
        </VFlex>

      </VLayout>
      <br>
      <VLayout>
        <VFlex
          xs12
        >
          <h2>
            Pickup Requests
          </h2>
          <VDataTable
            :headers="headers"
            :items="pickupRequests"
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <td>
                {{ props.item.transaction_id }}
              </td>
              <td>
                {{ props.item.service.service_title }}
              </td>
              <td>
                {{ props.item.pickup_date }}
              </td>
              <td>
                {{ props.item.status }}
              </td>
            </template>
          </VDataTable>
        </VFlex>
      </VLayout>
    </VContainer>

    <VLayout
      row
      justify-center
    >
      <VDialog
        v-model="requestCollection"
        scrollable
        max-width="300px"
      >
        <VCard>
          <VCardText>
            <VContainer grid-list-md>
              <h2>Request Pickup</h2>
              <VLayout wrap>
                <VFlex
                  xs12
                  sm12
                  md12
                  lg12
                >
                  <VTextField
                    slot="activator"
                    v-model="newPickupRequest.service_title"
                    label="Service Title"
                    readonly
                  />

                  <VDialog
                    v-model="dateDialog"
                    persistent
                    width="290px"
                  >
                    <VTextField
                      slot="activator"
                      v-model="newPickupRequest.pickupDate"
                      label="Date"
                      append-icon="event"
                      readonly
                    />
                    <VDatePicker
                      v-model="newPickupRequest.pickupDate"
                      header-color="#00baff"
                      color="#00baff"
                      hide-details
                      @input="onDateChange(newPickupRequest.pickupDate)"
                    />
                  </VDialog>
                  <VTextarea
                    v-model="newPickupRequest.notes"
                    name="input-7-1"
                    label="Additional Notes"
                  />
                  <VBtn
                    color="blue"
                    block
                    @click.native="request()"
                  >
                    Make Request
                  </VBtn>
                  <br>
                  <VBtn
                    color="blue"
                    block
                    outline
                    @click.native="requestCollection = !requestCollection"
                  >
                    Close
                  </VBtn>
                </VFlex>
              </VLayout>
            </VContainer>
          </VCardText>
        </VCard>
      </VDialog>
    </VLayout>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';

.routeHeader {
  display: inline-block;
}
.v-date-picker-title{
  color:black
}
.addButton {
  display: inline-block;
  float: right;
}
</style>
